import React, { Component } from "react";
import { Container } from "reactstrap";

//Slider
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import star from "../../assets/images/star-48.png";
import halfStar from "../../assets/images/star-half-48-outline-grey.png";

import profileJody from "../../assets/images/reviews/jody.jpg";
import profileAlec from "../../assets/images/reviews/alec.jpg";
import profileGaril from "../../assets/images/reviews/garil.jpg";

class Reviews extends Component {
  state = {
    clients: [
      {
        id: 1,
        img: "",
        name: "Irene Devoe",
        technology: "Web Development, USA",
        description:
          "Aeque porro quisquam est qui dolorem ipsum quia dolor sit amet consectetur numquam tempora.",
      },
      {
        id: 2,
        img: "",
        name: "Adrian Kidd",
        technology: "Web Designer, USA",
        description:
          "Et harum quidem a rerum that facilis est et expedita libero tempore soluta nobis cumque as impedit.",
      },
      {
        id: 3,
        img: "",
        name: "Shari Turner",
        technology: "Graphic Designer, USA",
        description:
          "Sed ut perspiciatis a unde omnis iste natus error sit as voluptatem accusantium laudantium.",
      },
      {
        id: 4,
        img: "",
        name: "Robert Story",
        technology: "Web Designer, USA",
        description:
          "Aeque porro quisquam est qui dolorem ipsum quia dolor sit amet consectetur numquam tempora.",
      },
      {
        id: 5,
        img: "",
        name: "Lisa Traxler",
        technology: "Graphic Designer, USA",
        description:
          "Et harum quidem a rerum that facilis est et expedita libero tempore soluta nobis cumque as impedit.",
      },
      {
        id: 6,
        img: "",
        name: "Michael Bang",
        technology: "Web Developer, USA",
        description:
          "Sed ut perspiciatis a unde omnis iste natus error sit as voluptatem accusantium laudantium.",
      },
      {
        id: 7,
        img: "",
        name: "Joyce Yates",
        technology: "Web Designer, USA",
        description:
          "Aeque porro quisquam est qui dolorem ipsum quia dolor sit amet consectetur numquam tempora.",
      },
    ],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      960: {
        items: 3,
      },
      1200: {
        items: 3,
      },
    },
  };
  render() {
    return (
      <React.Fragment>
        {/* <!-- TESTIMONIAL START --> */}

        <section className="section position-relative mt-4 pt-5" id="reviews">
          <Container className="bg-light-gray pr-4 pl-4">
            <div className="row text-center pt-5">
              <div className="col-8 mx-auto text-center">
                <div style={{fontSize: 1.5 + "rem"}}>
                  <span>Average patient rating</span>
                  <div className="d-inline-block ml-3 mr-3 average-rating">
                    <img alt="Rating star" src={star} />
                    <img alt="Rating star" src={star} />
                    <img alt="Rating star" src={star} />
                    <img alt="Rating star" src={star} />
                    <img alt="Rating star" src={halfStar} style={{width: 34, marginTop: -9}} />
                  </div>
                  <span className="font-weight-bold">4.5/5</span>
                </div>
                <p className="text-muted">Customer service rating based on 950 verified reviews.</p>
              </div>
            </div>
            <hr />
            <div className="row mt-3 pb-3 ml-3 pr-3">
              <OwlCarousel
                className="owl-theme client-images text-center"
                items={2}
                loop={true}
                margin={10}
                nav={false}
                dots={true}
                autoplay={true}
                responsive={this.state.responsive}
                autoplayHoverPause={true}
                autoplayTimeout={6500}
              >
                <div className="item">
                  <div className="text-center text-md-left m-3">
                    <img
                      src={profileJody}
                      alt="Jody profile"
                      className="d-block rounded-circle user-img mx-auto ml-md-0"
                      style={{width: 70, height: 70}}
                    />
                    <div className="rating mt-2">
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                    </div>
                    <h6 className="text-dark mt-2 f-18 mb-0">Easy to use, got my treatment within 2 hours</h6>
                    <p className="text-muted f-14">Jody Weston</p>
                  </div>
                </div>

                <div className="item">
                  <div className="text-center text-md-left m-3">
                    <img
                      src={profileAlec}
                      alt="Alec profile"
                      className="d-block rounded-circle user-img mx-auto ml-md-0"
                      style={{width: 70, height: 70}}
                    />
                    <div className="rating mt-2">
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                    </div>
                    <h6 className="text-dark mt-2 f-18 mb-0">I needed a second opinion and got one the same day</h6>
                    <p className="text-muted f-14">Alec West</p>
                  </div>
                </div>

                <div className="item">
                  <div className="text-center text-md-left m-3">
                    <img
                      src={profileGaril}
                      alt="Garil profile"
                      className="d-block rounded-circle user-img mx-auto ml-md-0"
                      style={{width: 70, height: 70}}
                    />
                    <div className="rating mt-2">
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                      <img alt="Rating star" className="rating-star" src={star} style={{height: 25, width: 25}} />
                    </div>
                    <h6 className="text-dark mt-2 f-18 mb-0">I now see my dermatologist without driving to the city</h6>
                    <p className="text-muted f-14">Galil Okto</p>
                  </div>
                </div>
              </OwlCarousel>
            </div>
          </Container>
        </section>
        {/* TESTIMONIAL END */}
      </React.Fragment>
    );
  }
}

export default Reviews;
